export default (value: string) => (value ? undefined : 'Required');
